<template>
  <div v-loading="dataLoading" class="register-done">
    <rhcn-drawer :showClose="false">
      <template slot="title"> </template>
      <div class="form">
        <div class="form-content">
          <span class="el-icon-success"></span>
          <span>{{$t("message.user.registerDoneDesc1")}}</span>
          <span v-html="$t('message.user.registerDoneDesc2', { second: `${countTime}s` })"></span>
        </div>
        <div class="margin-top-20">
          <el-button
            style="width: 100%"
            type="primary"
            @click="onSubmit"
            >{{$t("message.common.jumpNow")}}</el-button>
        </div>
      </div>
    </rhcn-drawer>
  </div>
</template>
<script>
import RhcnDrawer from '@/components/drawer/index.vue';

export default {
  components: {
    RhcnDrawer,
  },
  data() {
    return {
      dataLoading: false,
      countTime: 10,
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.countTime === 0) {
        this.onSubmit();
        return;
      }
      this.countTime -= 1;
    }, 1000);
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    onSubmit() {
      this.$router.replace({
        path: '/user/login',
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/element-variables.scss";

.register-done {
  .drawer-form-wrapper .form {
    width: 450px;
    .form-content {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 180px;
      margin-bottom: 90px;
      font-size: 16px;
      font-weight: 600;
      color: $color-text-primary;
      line-height: 22px;

      .el-icon-success {
        color: #00A2DD;
        font-size: 108px;
        line-height: 1;
        font-weight: normal;
        margin-bottom: 18px;
      }
    }
  }
}
</style>
